import { EventTypes } from '../../../types/event.types';
import type { EventHandlerMap } from '../../../libs/events/eventHandler';

export const reviewEventHandlers: EventHandlerMap = {
    [EventTypes.ReviewUpdated]: (event, queryClient, originId) => {
        if (event.originId !== originId) {
            queryClient.invalidateQueries({ queryKey: ['reviews', 'single', event.scopeId] });
        }
    },
};
